/**
 * Opinionated wrapper around window.matchMedia.
 *
 * Example usage:
 * new MqlMatchMedia(`(max-width:500px)`, (match) => {
 * 		if (match) {
 * 			this.initSlider()
 * 		} else {
 * 			this.destroySlider()
 * 		}
 * })
 */
class MqlMatchMedia {
	// Ensures that query is a string and callback is a function
	constructor(query, callback) {
		if (typeof query !== 'string') {
			throw new Error('Query must be a string')
		}
		if (typeof callback !== 'function') {
			throw new Error('Callback must be a function')
		}

		this.callback = callback
		this.boundOnMqlChange = this.onMqlChange.bind(this)
		this.isListenerAdded = false

		if (window.matchMedia) {
			this.mql = window.matchMedia(query)
			this.addChangeListener()
			this.onMqlChange()
		} else {
			console.warn('window.matchMedia is not supported by this browser.')
		}
	}

	addChangeListener() {
		this.mql.addEventListener('change', this.boundOnMqlChange)
		this.isListenerAdded = true
	}

	onMqlChange() {
		// Providing more context in the callback, such as the current state
		this.callback(this.mql.matches, this.mql)
	}

	destroy() {
		if (this.isListenerAdded) {
			this.mql.removeEventListener('change', this.boundOnMqlChange)
			this.isListenerAdded = false
		}
		this.mql = null
	}
}

export { MqlMatchMedia }
